export default "/_next/static/chunks/fonts/Channel4Chadwick-Bold-c88c3035e89486eab7c28977d6bb0086.woff2";